"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var PostStatus = function (_a) {
    var status = _a.status;
    var t = react_i18next_1.useTranslation('common').t;
    return status ? (react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.post_status, styles_module_scss_1.default[status]) },
        react_1.default.createElement("span", null, t('MY_ANNOUNCEMENTS.STATUS.' + status.toUpperCase())))) : null;
};
exports.default = PostStatus;
